module.exports = __webpack_public_path__ + "img/GDP_2.17970dc3.jpg";